import { generateRandomID } from "~/utils/generateRandomID";
import { Filter } from "../../types";
import { EditorFilter } from "../types";
import { ROOT_FILTER_ID } from "../../consts";

// // // //

/**
 * buildEditorFilter
 * Builds an EditorFilter from a Filter object.
 * @function buildEditorFilter
 * @param {Filter} filter - The Filter object to build the EditorFilter from.
 * @param {boolean} isRoot - Indicates whether the EditorFilter is the root filter.
 * @returns {EditorFilter} - The generated EditorFilter.
 */
export function buildEditorFilter(props: {
    filter: Filter;
    isRoot: boolean;
}): EditorFilter {
    const { filter, isRoot } = props;

    return {
        id: isRoot ? ROOT_FILTER_ID : generateRandomID(),
        state: filter,
        enabled: true,
        messages: [],
        nested: filter.filters
            ? filter.filters.map((f) =>
                  buildEditorFilter({ filter: f, isRoot: false }),
              )
            : [],
    };
}
